import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = { class: "list-group-item bg-white" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "text-muted" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_6 = {
  key: 2,
  class: "text-muted text-end"
}
const _hoisted_7 = {
  key: 3,
  class: "text-muted text-end"
}
const _hoisted_8 = {
  key: 4,
  class: "text-muted text-end"
}
const _hoisted_9 = {
  key: 5,
  class: "input-group"
}
const _hoisted_10 = {
  key: 6,
  class: "input-group"
}
const _hoisted_11 = {
  key: 7,
  class: "input-group"
}
const _hoisted_12 = { key: 8 }
const _hoisted_13 = { key: 9 }
const _hoisted_14 = ["value", "selected"]
const _hoisted_15 = { key: 10 }
const _hoisted_16 = {
  key: 11,
  class: "d-flex justify-content-end mt-2"
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 1,
  class: "scenario-field-alternating"
}
const _hoisted_19 = { class: "scenario-field-data" }
const _hoisted_20 = { class: "scenario-field-title" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "tooltip-container" }
const _hoisted_23 = {
  key: 0,
  class: "fas fa-info-circle"
}
const _hoisted_24 = { class: "tooltiptext tooltip-right" }
const _hoisted_25 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = {
  key: 2,
  class: "text-muted"
}
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = {
  key: 4,
  class: "input-group"
}
const _hoisted_30 = { key: 5 }
const _hoisted_31 = { class: "d-flex justify-content-end mt-2" }
const _hoisted_32 = {
  key: 6,
  class: "input-group"
}
const _hoisted_33 = ["value", "selected"]
const _hoisted_34 = {
  key: 7,
  class: "d-flex justify-content-start align-items-center"
}
const _hoisted_35 = ["value", "checked"]
const _hoisted_36 = { class: "form-check-label" }
const _hoisted_37 = { class: "btn-group btn-group-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_text_editor = _resolveComponent("text-editor")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_scenario_select_image = _resolveComponent("scenario-select-image")!
  const _component_user_image = _resolveComponent("user-image")!

  return (_ctx.listGroupItem)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("li", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.canEdit && !_ctx.edit)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.edit = true)),
                  class: "btn btn-link text-primary btn-sm"
                }, _cache[23] || (_cache[23] = [
                  _createElementVNode("i", { class: "fa fa-edit" }, null, -1)
                ])))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.label), 1)
          ]),
          (_ctx.type === 'editor' && !_ctx.edit)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: _ctx.value,
                class: "text-muted"
              }, null, 8, _hoisted_4))
            : (_ctx.type === 'tags' && !_ctx.edit)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: index,
                      class: "tag px-2 mx-1 badge badge-primary"
                    }, _toDisplayString(item.name.en), 1))
                  }), 128))
                ]))
              : (_ctx.type ==='money' && !_ctx.edit)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("strong", null, "$" + _toDisplayString(_ctx.value), 1)
                  ]))
                : (!_ctx.edit && _ctx.field === 'enable_giftcard')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.value === 1 ? 'Yes' : 'No'), 1)
                    ]))
                  : (!_ctx.edit)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString((_ctx.field === "giftcard_campaign_id" || _ctx.field === "institution_id") ? _ctx.getItemLabel(_ctx.value) : _ctx.value), 1))
                    : _createCommentVNode("", true),
          (_ctx.edit && _ctx.type === 'text')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.value]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.edit && _ctx.type === 'money')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "input-group-prepend" }, [
                  _createElementVNode("div", { class: "input-group-text" }, "$")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  min: "1",
                  step: "any",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.value) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.value]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.edit && _ctx.type === 'number')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  min: "1",
                  step: "any",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.value) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.value]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.edit && _ctx.type === 'editor')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_text_editor, {
                  options: _ctx.simpleEditorOptions,
                  modelValue: _ctx.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.value) = $event))
                }, null, 8, ["options", "modelValue"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.edit && _ctx.type === 'select')
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.value) = $event)),
                  class: "form-control"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: item.value,
                      selected: _ctx.value === item.value
                    }, _toDisplayString(item.label), 9, _hoisted_14))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.value]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.edit && _ctx.type === 'tags')
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_Multiselect, {
                  mode: "tags",
                  modelValue: _ctx.value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.value) = $event)),
                  options: _ctx.items,
                  searchable: true,
                  createTag: true
                }, null, 8, ["modelValue", "options"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.edit)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("button", {
                  disabled: _ctx.value==='',
                  class: "btn btn-primary",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.save(_ctx.value)))
                }, "Save", 8, _hoisted_17),
                _createElementVNode("button", {
                  class: "btn btn-default mx-2",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
                }, "Cancel")
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Loading, {
          active: _ctx.loading,
          "is-full-page": false
        }, null, 8, ["active"])
      ], 64))
    : (_openBlock(), _createElementBlock("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            (_ctx.canEdit && !_ctx.edit && _ctx.type === 'image-select')
              ? (_openBlock(), _createBlock(_component_scenario_select_image, {
                  key: 0,
                  modelValue: _ctx.value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.value) = $event)),
                  onSelected: _ctx.save
                }, {
                  trigger: _withCtx((triggerProps) => [
                    _createElementVNode("button", {
                      onClick: triggerProps.click,
                      class: "btn btn-link text-primary btn-sm"
                    }, _cache[25] || (_cache[25] = [
                      _createElementVNode("i", { class: "fa fa-edit" }, null, -1)
                    ]), 8, _hoisted_21)
                  ]),
                  _: 1
                }, 8, ["modelValue", "onSelected"]))
              : _createCommentVNode("", true),
            (_ctx.canEdit && !_ctx.edit && _ctx.type !== 'image-select')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.edit = true)),
                  class: "btn btn-link text-primary btn-sm"
                }, _cache[26] || (_cache[26] = [
                  _createElementVNode("i", { class: "fa fa-edit" }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (!_ctx.disableLabel)
              ? (_openBlock(), _createElementBlock("label", {
                  key: 2,
                  class: _normalizeClass({'text-danger':!_ctx.value && _ctx.required})
                }, [
                  _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
                  (!_ctx.value && _ctx.required)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass({'text-danger':!_ctx.value})
                      }, "*", 2))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_22, [
                    (_ctx.toolTip)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_23))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.toolTip), 1)
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["scenario-field-values", [_ctx.canEdit ? '' : 'no-editing']])
          }, [
            (_ctx.type === 'image-select')
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createVNode(_component_user_image, {
                    size: "ui-w-80",
                    source: _ctx.value
                  }, null, 8, ["source"])
                ]))
              : (_ctx.type === 'editor' && !_ctx.edit)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    innerHTML: _ctx.value,
                    class: "text-muted"
                  }, null, 8, _hoisted_26))
                : (!_ctx.edit && (_ctx.type === 'select' || _ctx.type === 'radio'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.getItemLabel(_ctx.value)), 1))
                  : (!_ctx.edit)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 3,
                        class: "text-muted",
                        innerHTML: _ctx.value
                      }, null, 8, _hoisted_28))
                    : _createCommentVNode("", true),
            (_ctx.edit && _ctx.type === 'text')
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.value) = $event)),
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.value]
                  ]),
                  _createElementVNode("span", null, [
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      type: "button",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.save(_ctx.value)))
                    }, "Save"),
                    _createElementVNode("button", {
                      class: "btn btn-secondary",
                      onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
                      type: "button"
                    }, "Cancel")
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.edit && _ctx.type === 'editor')
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createVNode(_component_text_editor, {
                    modelValue: _ctx.value,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.value) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.save(_ctx.value)))
                    }, "Save"),
                    _createElementVNode("button", {
                      class: "btn btn-default mx-2",
                      onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
                    }, "Cancel")
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.edit && _ctx.type === 'select')
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.value) = $event)),
                    class: "form-control"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: item.value,
                        selected: _ctx.value === item.value
                      }, _toDisplayString(item.label), 9, _hoisted_33))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.value]
                  ]),
                  _createElementVNode("span", null, [
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      type: "button",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.save(_ctx.value)))
                    }, "Save"),
                    _createElementVNode("button", {
                      class: "btn btn-secondary",
                      onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.cancelSelect && _ctx.cancelSelect(...args))),
                      type: "button"
                    }, "Cancel")
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.edit && _ctx.type === 'radio')
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                    return (_openBlock(), _createElementBlock("label", {
                      key: index,
                      class: "form-check form-check-inline p-o m-0 mx-2"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        class: "form-check-input",
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.value) = $event)),
                        value: item.value,
                        checked: item.value === _ctx.value
                      }, null, 8, _hoisted_35), [
                        [_vModelRadio, _ctx.value]
                      ]),
                      _cache[27] || (_cache[27] = _createTextVNode()),
                      _createElementVNode("span", _hoisted_36, _toDisplayString(item.label), 1)
                    ]))
                  }), 128)),
                  _createElementVNode("span", _hoisted_37, [
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      type: "button",
                      onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.save(_ctx.value)))
                    }, "Save"),
                    _createElementVNode("button", {
                      class: "btn btn-secondary",
                      onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
                      type: "button"
                    }, "Cancel")
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_Loading, {
              active: _ctx.loading,
              "is-full-page": false
            }, null, 8, ["active"])
          ], 2)
        ])
      ]))
}